export var Z3KObject;
(function (Z3KObject) {
    function cmp_by_id(a, b) {
        if (a.id < b.id)
            return -1;
        if (a.id > b.id)
            return +1;
        return 0;
    }
    Z3KObject.cmp_by_id = cmp_by_id;
})(Z3KObject || (Z3KObject = {}));
export function get_z3k_object_state(z3k_state, object_id) {
    return z3k_state?.[object_id];
}
export var Z3KObjectId;
(function (Z3KObjectId) {
    Z3KObjectId[Z3KObjectId["AnalogInput"] = 0] = "AnalogInput";
    Z3KObjectId[Z3KObjectId["WiredTemperatureSensor"] = 1] = "WiredTemperatureSensor";
    Z3KObjectId[Z3KObjectId["GuardZone"] = 2] = "GuardZone";
    Z3KObjectId[Z3KObjectId["Notification"] = 3] = "Notification";
    Z3KObjectId[Z3KObjectId["User"] = 4] = "User";
    Z3KObjectId[Z3KObjectId["OutputAction"] = 5] = "OutputAction";
    Z3KObjectId[Z3KObjectId["BoilerAdapter"] = 6] = "BoilerAdapter";
    Z3KObjectId[Z3KObjectId["RadioModule"] = 7] = "RadioModule";
    Z3KObjectId[Z3KObjectId["RadioSensor"] = 8] = "RadioSensor";
    Z3KObjectId[Z3KObjectId["Command"] = 9] = "Command";
    Z3KObjectId[Z3KObjectId["WebElement"] = 10] = "WebElement";
    Z3KObjectId[Z3KObjectId["Scenario"] = 11] = "Scenario";
    Z3KObjectId[Z3KObjectId["Buzzer"] = 12] = "Buzzer";
    Z3KObjectId[Z3KObjectId["GuardIndicator"] = 13] = "GuardIndicator";
    Z3KObjectId[Z3KObjectId["RelayControl"] = 14] = "RelayControl";
    Z3KObjectId[Z3KObjectId["ThreewayTap"] = 15] = "ThreewayTap";
    Z3KObjectId[Z3KObjectId["HeatingCircuit"] = 16] = "HeatingCircuit";
    Z3KObjectId[Z3KObjectId["Pump"] = 17] = "Pump";
    Z3KObjectId[Z3KObjectId["TMKey"] = 18] = "TMKey";
    Z3KObjectId[Z3KObjectId["UserRole"] = 19] = "UserRole";
    Z3KObjectId[Z3KObjectId["HeatingMode"] = 20] = "HeatingMode";
    Z3KObjectId[Z3KObjectId["DayTimetable"] = 21] = "DayTimetable";
    Z3KObjectId[Z3KObjectId["WeekTimetable"] = 22] = "WeekTimetable";
    Z3KObjectId[Z3KObjectId["RadioTag"] = 23] = "RadioTag";
    Z3KObjectId[Z3KObjectId["IOExtension"] = 24] = "IOExtension";
    Z3KObjectId[Z3KObjectId["Pza"] = 25] = "Pza";
    Z3KObjectId[Z3KObjectId["BoilerGroup"] = 26] = "BoilerGroup";
    Z3KObjectId[Z3KObjectId["AnalogTemperatureSensor"] = 27] = "AnalogTemperatureSensor";
    Z3KObjectId[Z3KObjectId["NTCTemperatureCurve"] = 28] = "NTCTemperatureCurve";
    Z3KObjectId[Z3KObjectId["Fob"] = 29] = "Fob";
    Z3KObjectId[Z3KObjectId["FobButton"] = 30] = "FobButton";
    Z3KObjectId[Z3KObjectId["RadioSensor433"] = 31] = "RadioSensor433";
    Z3KObjectId[Z3KObjectId["OuterPanel"] = 32] = "OuterPanel";
    Z3KObjectId[Z3KObjectId["TimeInterval"] = 33] = "TimeInterval";
    Z3KObjectId[Z3KObjectId["IntervalTimetable"] = 34] = "IntervalTimetable";
    Z3KObjectId[Z3KObjectId["AnalogDut"] = 35] = "AnalogDut";
    Z3KObjectId[Z3KObjectId["CalibrationTable"] = 36] = "CalibrationTable";
    Z3KObjectId[Z3KObjectId["DigitalDut"] = 37] = "DigitalDut";
    Z3KObjectId[Z3KObjectId["RadioDut"] = 38] = "RadioDut";
    Z3KObjectId[Z3KObjectId["GraphPanel"] = 39] = "GraphPanel";
    Z3KObjectId[Z3KObjectId["BoilerCascade"] = 40] = "BoilerCascade";
    Z3KObjectId[Z3KObjectId["DutSettings"] = 41] = "DutSettings";
    Z3KObjectId[Z3KObjectId["UIGroup"] = 42] = "UIGroup";
    Z3KObjectId[Z3KObjectId["ObjectArrays"] = 43] = "ObjectArrays";
    Z3KObjectId[Z3KObjectId["Accelerometer"] = 44] = "Accelerometer";
    Z3KObjectId[Z3KObjectId["Pause"] = 45] = "Pause";
    Z3KObjectId[Z3KObjectId["ConditionalOperator"] = 46] = "ConditionalOperator";
    Z3KObjectId[Z3KObjectId["Comparator"] = 47] = "Comparator";
    Z3KObjectId[Z3KObjectId["LogicExpression"] = 48] = "LogicExpression";
    Z3KObjectId[Z3KObjectId["SensorReading"] = 49] = "SensorReading";
    Z3KObjectId[Z3KObjectId["TimeComparator"] = 50] = "TimeComparator";
    Z3KObjectId[Z3KObjectId["ModBusDevice"] = 51] = "ModBusDevice";
    Z3KObjectId[Z3KObjectId["ModBusSignal"] = 52] = "ModBusSignal";
    Z3KObjectId[Z3KObjectId["AnalogOutput"] = 53] = "AnalogOutput";
    Z3KObjectId[Z3KObjectId["Signal"] = 54] = "Signal";
    Z3KObjectId[Z3KObjectId["Slot"] = 55] = "Slot";
    Z3KObjectId[Z3KObjectId["StopScenario"] = 56] = "StopScenario";
    Z3KObjectId[Z3KObjectId["MQTTTopic"] = 57] = "MQTTTopic";
})(Z3KObjectId || (Z3KObjectId = {}));
